module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-ruled-fill-40d75e84.svg";